<template>
	<div class="footer" :class="{ loaded: loaded }">
		<MaoInfo :status="info" @close="info = false" />

		<div class="grid-x">
			<div class="copyright col-1-start col-12-end label-big	">

				<div class="left-footer">
					<img :src="imageCredits" class="image-credit" />
				</div>

				<div class="right-footer">
					<p>{{ labels['© 2025 Museum of Oriental Art of Turin.'] }}</p>
					<p>{{ labels['All rights reserved.'] }}</p>
					<div class="buttons">
						<MaoButton variant="secondary" @open="openInfo" :label="labels['Credits']" />
						<MaoButton variant="secondary" @open="openPrivacyPolicy" :label="labels['Privacy Policy']" />
						<MaoButton variant="secondary" @open="openCookiePolicy" :label="labels['Cookie Policy']" />
						<MaoButton variant="secondary" @open="cookieSettings = true" class="settings-cookie-button" icon="settings" />
					</div>
				</div>

			</div>
		</div>

		<div class="privacy-policy" v-if="privacyPolicy">
			<div class="privacy-policy-description" v-html="appDataStore.appData.pages['privacy-policy'].description" />
			<MaoButton class="close-privacy-policy" variant="opacity-light" icon="close"
				@click="privacyPolicy = false" />
		</div>

		<div class="cookie-settings">
			<MaoOverlay :status="cookieSettings"> </MaoOverlay>
			<MaoAlert :status="cookieSettings" @close="cookieSettings = false">
				<h3>{{ labels['Settings Cookie'] }}</h3>

				<div class="settings-cookie-input">
					<label>
						<input type="checkbox" v-model="cookieConsent">
						<span>{{ labels['I consent to the use of cookies to ensure the best experience on this website.'] }}</span>
					</label>
				</div>

				<div class="buttons">
					<MaoButton variant="alert" label="Salva" fullwidth @click="saveCookieSettings" />
				</div>
			</MaoAlert>
		</div>

	</div>
</template>

<script>
import { useAppDataStore } from "@/stores/appData";
import { useGlobalActionsStore } from "@/stores/globalActions";
import MaoInfo from "./MaoInfo.vue";
import MaoButton from "./MaoButton.vue";
import MaoAlert from "./MaoAlert.vue";
import MaoOverlay from "./MaoOverlay.vue";

export default {
	components: {
		MaoInfo,
		MaoButton,
		MaoAlert,
		MaoOverlay,
	},
	data() {
		return {
			info: false,
			privacyPolicy: false,
			cookieSettings: false,
			cookieConsent: localStorage.getItem('cookie_consent') === 'granted'
		}
	},
	setup() {
		const appDataStore = useAppDataStore();
		const globalActionsStore = useGlobalActionsStore();
		return { appDataStore, globalActionsStore };
	},
	methods: {
		openInfo() {
			this.globalActionsStore.hideHeader();
			this.info = true;
		},
		openPrivacyPolicy() {
			this.globalActionsStore.hideHeader();
			this.privacyPolicy = true;
		},
		openCookiePolicy() {
			window.open('https://www.fondazionetorinomusei.it/it/privacy/', '_blank');
		},
		saveCookieSettings() {
			const previous = localStorage.getItem('cookie_consent') || 'denied';
			const newState = this.cookieConsent ? 'granted' : 'denied';

			// aggiorna localStorage
			localStorage.setItem('cookie_consent', newState);

			// aggiorna Consent Mode se GTM è già caricato
			if (typeof window.gtag === 'function') {
				window.gtag('consent', 'update', {
					ad_storage: newState,
					analytics_storage: newState
				});
			}

			this.cookieSettings = false;   // chiudi modale

			// se lo stato è cambiato, ricarica la pagina
			if (previous !== newState) {
				location.reload();
			}
		}
	},
	computed: {
		imageCredits() {

			return this.appDataStore.appData.pages.about['image-credits-footer'].full;
		},
		labels() {
			return this.appDataStore.appData.labels;
		},
		loaded() {
			return this.appDataStore.appData.loaded;
		},
	},
};
</script>

<style scoped lang="scss">
.image-credit {
	max-width: 250px;
}

.privacy-policy {
	position: fixed;
	inset: 0;
	background: black;
	z-index: 10;
	padding: 1rem;
	overflow-y: scroll;
	padding-bottom: 10rem;
	padding-top: 5rem;

	.privacy-policy-description {
		display: flex;
		flex-direction: column;
		gap: 1rem;
	}

	.close-privacy-policy {
		position: fixed;
		top: 1rem;
		right: 2rem;
		z-index: 100;
	}

}

.buttons {
	display: flex;
	gap: 0.5rem;
	align-items: flex-start;
}

.settings-cookie-input {
	input {
		width: 1.3rem;
		height: 1.3rem;
		border-radius: 0;
		accent-color: #217e83;
	}
}

.settings-cookie-button {
	padding: 0.4rem;
}

label {
	display: flex;
	gap: 0.5rem;
	span {
		width: calc(100% - 1.5rem);
	}
}

.footer {
	position: relative;
	padding: var(--padding-xl) 0;
	background-color: var(--surface-contrast-container-high);
	color: var(--text-on-surface-invert);
	opacity: 0;
	pointer-events: none;
	transition: all 0.3s;
	padding-bottom: 6rem;

	.left-footer,
	.right-footer {
		gap: 1rem;
		align-items: flex-start;
		display: flex;
		width: 50%;
		flex-direction: column;

		@include breakpoint(s) {
			width: 100%;
		}
	}

	&.loaded {
		opacity: 1;
		pointer-events: all;
	}

	.copyright {
		display: flex;
		gap: 1rem;

		@include breakpoint(s) {
			flex-direction: column;
		}
	}

	.open-info {
		color: var(--text-on-surface-invert);
		text-decoration: underline;
		cursor: pointer;
	}

}
</style>